<template>
	<div class="rt">
		<el-row
			v-loading="isloading"
			class="reports-tablePT"
			style="margin-top: 14px"
		>
			<el-col :span="24">
				<el-table
					style="text-transform: capitalize; word-break: break-word"
					height="500"
					:data="
						filteredreportsTableP_T
							.filter(
								(el) =>
									!selected_Location.length ||
									selected_Location.includes(el.store_name)
							)
							.filter(
								(el) =>
									!selected_EmpId.length || selected_EmpId.includes(el.emp_id)
							)
							.filter(
								(el) =>
									!selected_Employee.length ||
									selected_Employee.includes(el.name)
							)
							.filter(
								(el) =>
									!selected_Designation.length ||
									selected_Designation.includes(el.designation)
							)
							.filter(
								(el) =>
									!selected_Region.length || selected_Region.includes(el.region)
							)
							.filter(
								(el) =>
									!selected_SubRegion.length ||
									selected_SubRegion.includes(el.subregion)
							)

							.filter(
								(el) =>
									!search ||
									el.store_name.toLowerCase().includes(search.toLowerCase())
							)
							.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
					"
				>
					<el-table-column
						fixed
						width="160px"
						sortable
						prop="store_id"
						label="Location Id"
						style="word-break: break-word"
					>
					</el-table-column>

					<el-table-column fixed width="160px" label="Location">
						<template slot="header" slot-scope="scope">
							Location
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Location"
									size="mini"
									:placeholder="`Search ${
										viewBy == 'location' ? 'Location' : 'User'
									}`"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Location">
										<el-checkbox
											v-for="(formItem, index) in uniqueLocationNames.filter(
												(el) =>
													!searched_Location ||
													el
														.toLowerCase()
														.includes(searched_Location.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Location = [...uniqueLocationNames]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Location = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Location.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<div style="text-transform: capitalize; word-break: break-word">
								{{
									scope.row.store_name != undefined ? scope.row.store_name : "-"
								}}
							</div>
						</template>
					</el-table-column>

					<el-table-column
						width="160px"
						sortable
						prop="project_start_date"
						label="Start Date"
						style="word-break: break-word"
					>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{
									scope.row.project_start_date != 0
										? moment(scope.row.project_start_date).format("Do MMM YYYY")
										: "-"
								}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						sortable
						prop="project_end_date"
						label="End Date"
						style="word-break: break-word"
					>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{
									scope.row.project_end_date != 0
										? moment(scope.row.project_end_date).format("Do MMM YYYY")
										: "-"
								}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="190px"
						sortable
						prop="project_completion_date"
						label="Completion Date"
						style="word-break: break-word"
					>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{
									scope.row.project_completion_date != 0
										? moment
												.utc(scope.row.project_completion_date)
												.local()
												.format("Do MMM YYYY")
										: "-"
								}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						prop="emp_id"
						label="Employee id"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Employee Id
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_EmpId"
									size="mini"
									placeholder="Search Employee Id"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_EmpId">
										<el-checkbox
											v-for="(formItem, index) in uniqueEmpId.filter(
												(el) =>
													!searched_EmpId ||
													el
														.toString()
														.toLowerCase()
														.includes(searched_EmpId.toString().toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_EmpId = [...uniqueEmpId]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_EmpId = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_EmpId.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{
									scope.row.emp_id != 0
										? scope.row.emp_id
										: scope.row.emp_id != undefined
										? scope.row.emp_id
										: "-"
								}}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						prop="name"
						label="Employee"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Employee
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Employee"
									size="mini"
									placeholder="Search Employee"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Employee">
										<el-checkbox
											v-for="(formItem, index) in uniqueEmployee.filter(
												(el) =>
													!searched_Employee ||
													el
														.toLowerCase()
														.includes(searched_Employee.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Employee = [...uniqueEmployee]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Employee = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Employee.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{ scope.row.name != 0 ? scope.row.name : "-" }}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						prop="designation"
						label="Designation"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Designation
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Designation"
									size="mini"
									placeholder="Search Employee"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Designation">
										<el-checkbox
											v-for="(formItem, index) in uniqueDesignation.filter(
												(el) =>
													!searched_Designation ||
													el
														.toLowerCase()
														.includes(searched_Designation.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Designation = [...uniqueDesignation]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Designation = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Designation.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
						<template slot-scope="scope">
							<div style="word-break: break-word">
								{{ scope.row.designation != 0 ? scope.row.designation : "-" }}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						prop="region"
						label="Region"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Region
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_Region"
									size="mini"
									placeholder="Search Employee"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_Region">
										<el-checkbox
											v-for="(formItem, index) in uniqueRegion.filter(
												(el) =>
													!searched_Region ||
													el
														.toLowerCase()
														.includes(searched_Region.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_Region = [...uniqueRegion]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_Region = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_Region.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column
						width="160px"
						prop="subregion"
						label="Sub Region"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Sub Region
							<el-popover placement="right" trigger="click">
								<el-input
									v-model="searched_SubRegion"
									size="mini"
									placeholder="Search Employee"
								></el-input>
								<div
									style="max-height: 200px; overflow: auto; margin-top: 10px"
								>
									<el-checkbox-group v-model="selected_SubRegion">
										<el-checkbox
											v-for="(formItem, index) in uniqueSubRegion.filter(
												(el) =>
													!searched_SubRegion ||
													el
														.toLowerCase()
														.includes(searched_SubRegion.toLowerCase())
											)"
											:key="index"
											class="mb-2 checkbox-lable"
											:label="formItem"
											style="display: block"
										></el-checkbox>
									</el-checkbox-group>
								</div>
								<div class="flex justify-between mt-4">
									<span
										class="text-xs cursor-pointer primary-theme-color"
										@click="selected_SubRegion = [...uniqueSubRegion]"
										>Select all</span
									>
									<span
										class="text-xs cursor-pointer"
										@click="selected_SubRegion = []"
										>Reset</span
									>
								</div>
								<span slot="reference">
									<img
										v-if="selected_SubRegion.length"
										src="../../../../assets/images/filter.png"
										width="9"
										class="cursor-pointer"
									/>
									<img
										v-else
										src="../../../../assets/images/filterBlack.png"
										width="9"
										class="cursor-pointer"
									/>
								</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column
						prop="total_score"
						width="190px"
						style="word-break: break-word"
						v-if="showScore"
					>
						<template slot="header" slot-scope="scope">
							Points Available
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_Pscore_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = '';
										last_Ppoints_available_order = '';
										last_Pscore_order = 'asc';
									"
								></i>
								<i
									v-if="last_Pscore_order == '' || last_Pscore_order == 'asc'"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = '';
										last_Ppoints_available_order = '';
										last_Pscore_order = 'desc';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="current_score"
						width="190px"
						style="word-break: break-word"
					>
						<template slot="header" slot-scope="scope">
							Points Achieved
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_Ppoints_achieved_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = 'asc';
										last_Pscore_order = '';
										last_Ppoints_available_order = '';
									"
								></i>
								<i
									v-if="
										last_Ppoints_achieved_order == '' ||
										last_Ppoints_achieved_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = 'desc';
										last_Pscore_order = '';
										last_Ppoints_available_order = '';
									"
								></i>
							</span>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showScore"
						prop="score_completion_%"
						width="160px"
					>
						<template slot="header" slot-scope="scope">
							Score %
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_Pscore_completion_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = 'asc';
										last_Ppoints_available_order = '';
										last_Pscore_order = '';
										last_Ppoints_achieved_order = '';
									"
								></i>
								<i
									v-if="
										last_Pscore_completion_order == '' ||
										last_Pscore_completion_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = '';
										last_status_order = '';
										last_Pscore_completion_order = 'desc';
										last_Ppoints_available_order = '';
										last_Pscore_order = '';
										last_Ppoints_achieved_order = '';
									"
								></i>
							</span>
						</template>
						<template slot-scope="scope">
							<div>{{ scope.row["score_completion_%"] }}%</div>
						</template>
					</el-table-column>
					<el-table-column
						v-if="showCompletion"
						width="160px"
						prop="forms_completion_%"
					>
						<template slot="header" slot-scope="scope">
							Completion %
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_Pcompletion_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = 'asc';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = '';
										last_Pscore_order = '';
										last_Ppoints_available_order = '';
									"
								></i>
								<i
									v-if="
										last_Pcompletion_order == '' ||
										last_Pcompletion_order == 'asc'
									"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									v-on:click="
										last_Pcompletion_order = 'desc';
										last_status_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_achieved_order = '';
										last_Pscore_order = '';
										last_Ppoints_available_order = '';
									"
								></i>
							</span>
						</template>
						<template slot-scope="scope">
							<div>{{ scope.row["forms_completion_%"] }}%</div>
						</template>
					</el-table-column>
					<el-table-column prop="grade" label="Grade">
						<template slot-scope="scope">
							<div>{{ scope.row["grade"] }}</div>
						</template>
					</el-table-column>
					<el-table-column width="160px" prop="status">
						<template slot="header" slot-scope="scope">
							Status
							<span slot="reference" class="cursor-pointer">
								<i
									v-if="last_status_order == 'desc'"
									class="el-icon-caret-top"
									style="font-size: 12px"
									v-on:click="
										last_status_order = 'asc';
										last_Pcompletion_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_available_order = '';
										last_Pscore_order = '';
										last_Ppoints_achieved_order = '';
									"
								></i>
								<i
									v-if="last_status_order == '' || last_status_order == 'asc'"
									class="el-icon-caret-bottom"
									style="font-size: 12px"
									v-on:click="
										last_status_order = 'desc';
										last_Pcompletion_order = '';
										last_Pscore_completion_order = '';
										last_Ppoints_available_order = '';
										last_Pscore_order = '';
										last_Ppoints_achieved_order = '';
									"
								></i>
							</span>
						</template>

						<template slot-scope="scope">
							<el-tag
								size="small"
								style="border-radius: 12px; width: 80px; text-align: center"
								:style="
									scope.row.status != 'inprogress'
										? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
										: 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
								"
								>{{
									scope.row.status != "inprogress" ? "Completed" : "Incomplete"
								}}
							</el-tag>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row :gutter="10" class="mt-3">
			<el-col :span="8" class="text-left">
				<div>
					<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
					{{ filteredreportsTableP_T.length }} results
				</div>
			</el-col>
			<el-col :span="8" class="text-center">
				<el-select
					v-model="perPage"
					name="per_page"
					placeholder="select per page"
					style="width: 90px !important"
					size="mini"
				>
					<el-option label="10" :value="10"></el-option>
					<el-option label="25" :value="25"></el-option>
					<el-option label="50" :value="50"></el-option>
					<el-option label="100" :value="100"></el-option>
				</el-select>
				&nbsp;<b>per page</b>
			</el-col>
			<el-col :span="8" class="text-right">
				<el-pagination
					background
					layout="prev, pager, next"
					:total="filteredreportsTableP_T.length"
					:page-size="perPage"
					:current-page.sync="currentPage"
				></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
var moment = require("moment");
export default {
	props: {
		reportsTable1: Array,
		showScore: Boolean,
		showCompletion: Boolean,
		viewBy: String,
		search: String,
	},
	data: () => ({
		moment: moment,
		currentPage: 1,
		perPage: 10,
		searched_Location: "",
		last_occurance_order: "",
		last_completed_order: "",
		last_completion_order: "",
		last_points_achieved_oeder: "",
		last_average_score_order: "",
		last_total_points_order: "",
		last_score_order: "",
		last_Pcompletion_order: "",
		last_Pscore_completion_order: "",
		last_Ppoints_achieved_order: "",
		last_Ppoints_available_order: "",
		last_Pscore_order: "",
		selected_EmpId: [],
		selected_Employee: [],
		selected_Region: [],
		selected_SubRegion: [],
		last_status_order: "",
		selected_Designation: [],
		searched_EmpId: "",
		searched_Employee: "",
		searched_Region: "",
		searched_SubRegion: "",
		searched_Designation: "",
		isloading: false,
		selected_Location: [],
	}),
	computed: {
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				[...this.reportsTable1].length
			);
			return end;
		},
		uniqueLocationNames() {
			let arr = [
				...new Set([...this.reportsTable1].map((el) => el.store_name)),
			];
			return arr;
		},
		uniqueEmpId() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) => (el.emp_id != 0 ? el.emp_id : ""))
				),
			];
			return arr;
		},
		uniqueEmployee() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) => (el.name != 0 ? el.name : ""))
				),
			];
			return arr;
		},
		uniqueRegion() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) => (el.region != 0 ? el.region : ""))
				),
			];
			return arr;
		},
		uniqueSubRegion() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) =>
						el.subregion != 0 ? el.subregion : ""
					)
				),
			];
			return arr;
		},
		uniqueDesignation() {
			let arr = [
				...new Set(
					[...this.reportsTable1].map((el) =>
						el.designation != 0 ? el.designation : ""
					)
				),
			];
			return arr;
		},
		filteredreportsTableP_T() {
			let arr1 = this.reportsTable1;
			if (this.last_status_order) {
				if (this.last_status_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["status"].localeCompare(b["status"]));
				}
				if (this.last_status_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["status"].localeCompare(a["status"]));
				}
			}
			if (this.last_Pcompletion_order) {
				if (this.last_Pcompletion_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort(
						(a, b) => a["forms_completion_%"] - b["forms_completion_%"]
					);
				}
				if (this.last_Pcompletion_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort(
						(a, b) => b["forms_completion_%"] - a["forms_completion_%"]
					);
				}
			}
			if (this.last_Pscore_completion_order) {
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["score_completion_%"] - b["score_completion_%"]
					);
				}
				if (
					this.last_Pscore_completion_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["score_completion_%"] - a["score_completion_%"]
					);
				}
			}
			if (this.last_Pscore_order) {
				if (this.last_Pscore_order.toString().toLowerCase() == "asc") {
					arr1 = arr1.sort((a, b) => a["total_score"] - b["total_score"]);
				}
				if (this.last_Pscore_order.toString().toLowerCase() == "desc") {
					arr1 = arr1.sort((a, b) => b["total_score"] - a["total_score"]);
				}
			}

			if (this.last_Ppoints_achieved_order) {
				if (
					this.last_Ppoints_achieved_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort((a, b) => a["current_score"] - b["current_score"]);
				}
				if (
					this.last_Ppoints_achieved_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort((a, b) => b["current_score"] - a["current_score"]);
				}
			}
			if (this.last_Ppoints_available_order) {
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "asc"
				) {
					arr1 = arr1.sort(
						(a, b) => a["completed_total_score"] - b["completed_total_score"]
					);
				}
				if (
					this.last_Ppoints_available_order.toString().toLowerCase() == "desc"
				) {
					arr1 = arr1.sort(
						(a, b) => b["completed_total_score"] - a["completed_total_score"]
					);
				}
			}
			this.$forceUpdate();
			return arr1;
		},
	},
};
</script>

<style lang="scss">
.rt {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.reports-tablePT {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
			border-top: none;
			border-right: none;
			border-bottom: none;
			border-left: none;
		}
		tbody tr td {
			text-align: left !important;
			border-top: none;
			border-right: none;
			border-bottom: 1px solid #ebeef5;
			border-left: none;
		}
		.el-table thead.is-group th.el-table__cell {
			background: white !important;
			border-top: none;
			border-right: none;
			border-bottom: 1px solid #ebeef5;
			border-left: none;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: none;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			overflow-x: auto;
			min-height: 63vh;
			max-height: 63vh;
		}
		.el-table--border,
		.el-table--group {
			border: none;
		}
	}
}
</style>
